export default {
  form: {
    shipping_company_name: {
      label: 'Virksomhed',
      placeholder: 'Indtast virksomhedsnavn',
    },
    shipping_phone_number: {
      label: 'Telefonnummer',
      placeholder: 'Indtast telefonnummer',
    },
    shipping_salutation: {
      label: 'Titel',
      options: {
        mr: 'Hr.',
        mrs: 'Fru',
      },
    },
    shipping_first_name: {
      label: 'Fornavn',
      placeholder: 'Indtast fornavn',
    },
    shipping_last_name: {
      label: 'Efternavn',
      placeholder: 'Indtast efternavn',
    },
  },
  buttons: {
    back: 'Tilbage',
    next: 'Næste',
  },
};
